import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgYouTube({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.582 7.186C22 8.746 22 12 22 12s0 3.254-.418 4.814a2.505 2.505 0 01-1.768 1.768C18.254 19 12 19 12 19s-6.254 0-7.814-.418a2.505 2.505 0 01-1.768-1.768C2 15.254 2 12 2 12s0-3.254.418-4.814c.23-.86.908-1.538 1.768-1.768C5.746 5 12 5 12 5s6.254 0 7.814.418c.86.23 1.538.908 1.768 1.768zm-11.515 7.698l5.268-2.963-5.268-2.963v5.926z"
        fill={color}
      />
    </svg>
  )
}

export default SvgYouTube
